import { logger as N } from "../../shared-lib/index.js";
import Xt from "../models/backend-errors.js";
import { getErrorMessage as si } from "./error-utils.js";
const l = {
  Y: (t) => {
    let e, o;
    try {
      const r = () => {
        N.error("This browser does not have any supported ajax options!");
      };
      let n = !1;
      if ((window.XMLHttpRequest && (n = !0), !n)) return void r();
      e = new XMLHttpRequest();
      const s = () => {
        "function" == typeof t.error && t.error(e.status),
          "function" == typeof t.os && t.os(!1);
      };
      (e.onload = () => {
        let o = !1;
        if (4 === e.readyState)
          if (
            ((o = (e.status >= 200 && e.status < 300) || 304 === e.status), o)
          ) {
            if ("function" == typeof t.ss) {
              let o, r;
              try {
                (o = JSON.parse(e.responseText)),
                  (r = e.getAllResponseHeaders());
              } catch (o) {
                const n = {
                  error: "" === e.responseText ? Xt.Tu : Xt.ku,
                  response: e.responseText,
                };
                (0, t.ss)(n, r);
              }
              o && t.ss(o, r);
            }
            "function" == typeof t.os && t.os(!0);
          } else s();
      }),
        (e.onerror = () => {
          s();
        }),
        (e.ontimeout = () => {
          s();
        }),
        (o = JSON.stringify(t.data)),
        e.open("POST", t.url, !0),
        e.setRequestHeader("Content-type", "application/json"),
        e.setRequestHeader("X-Requested-With", "XMLHttpRequest");
      const i = t.headers || [];
      for (const t of i) e.setRequestHeader(t[0], t[1]);
      e.send(o);
    } catch (t) {
      N.error(`Network request error: ${si(t)}`);
    }
  },
};
export const readResponseHeaders = (t) => {
  const e = {},
    o = t.toString().split("\r\n");
  if (!o) return e;
  let r, n;
  for (const t of o)
    t &&
      ((r = t.slice(0, t.indexOf(":")).toLowerCase().trim()),
      (n = t.slice(t.indexOf(":") + 1).trim()),
      (e[r] = n));
  return e;
};
export default l;
